import { render, staticRenderFns } from "./WarrantyRequestForm.vue?vue&type=template&id=2c5182c4"
import script from "./WarrantyRequestForm.vue?vue&type=script&lang=js"
export * from "./WarrantyRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports